import type { User } from '~/server/types';
import { getTileEditableItems } from '~/modules/directory/util/tile-helpers';
import type { ProjectTileProps } from '~/modules/projects-category/util/project-tile-view-model.server';
import type { SearchResultItem } from '~/modules/search';
import type { TileViewModel } from '../type/util';
import { getProjectTileThumbnail } from '~/utils';

export interface ProjectTileViewModel extends TileViewModel<ProjectTileProps> {
    projectId: number;
    sliderImages: string[];
}
export const mapESProjectTileViewModel = (
    project: SearchResultItem,
    size: ProjectTileProps['size'] = 'medium',
    isMobile?: boolean,
    user?: User,
): ProjectTileViewModel => {
    const { Link, ProfessionalID, ProfessionalLink } = project;
    return {
        tile: {
            size,
            image: getProjectTileImage(project, isMobile, false),
            projectName: project.Title ?? '',
            projectLink: project.Link ?? '',
            professionalID: project.ProfessionalID ?? 0,
            professionalName: project.Professional ?? '',
            professionalLink: project.ProfessionalLink ?? '',
            projectID: project.id,
            hasAwards: project.HasAwards ?? false,
            viewedCount: project.TotalViewedCount ?? 0,
            savedCount: project.TotalSavedCount ?? 0,
            ...getTileEditableItems({
                professional: {
                    ID: ProfessionalID || 0,
                    Link: ProfessionalLink || '',
                },
                itemType: 'projects',
                itemLink: Link || '',
                user,
            }),
        },
        sliderImages: getProjectTileImage(project, isMobile, true),
        link: project.Link ?? '',
        projectId: project.id,
    };
};

const getProjectTileImage = (
    project: SearchResultItem,
    isMobile?: boolean,
    mapMultipleImages?: boolean,
) => {
    if (mapMultipleImages) {
        return project.DirectoryTiles?.map((i) => i.Thumb || '') || [];
    }

    const preferred = getProjectTileThumbnail(project, isMobile);

    if (preferred) {
        return [preferred];
    }
    return [];
};
